var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVivo119(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 663 912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.38,168.39c.07,32.5-11.3,83.24-46.94,119.12a184.14,184.14,0,0,1-32.08,25.89c-16.72,10.91-28.88,18.51-22,36.7,6.69,17.81,27.36,12.24,47,7.76,6.31-1.55,129.35-31.37,130.92-31.44a62.88,62.88,0,0,1,72.91,47l10.06,41.67A63.1,63.1,0,0,1,618,490.4c-1.39.61-135.86,33.39-136.09,33.44-25.53,6.58-40.48,19.35-40.38,44.08,0,11,6.41,23,14.29,32.93,0,0,146.63,181.31,147.36,182.73a63.1,63.1,0,0,1-10.76,86.18l-33.19,27.11a62.73,62.73,0,0,1-86.39-6.61c-1.19-1-92.26-112.66-101.91-124.54S349.1,735.88,332.23,736s-28.83,18.14-38.46,30-100.16,124-101.28,125A62.77,62.77,0,0,1,106.11,898c-.28-.25-33.19-26.93-33.29-26.95A63.2,63.2,0,0,1,61.57,785c.71-1.42,146.5-183.47,146.5-183.47,7.81-10,14.16-22,14.14-33-.1-24.72-15-37.41-40.64-43.87-.22,0-134.84-32.17-136.21-32.76A63.13,63.13,0,0,1,1.71,416.73c.05-.38,9.8-41.62,9.85-41.75a62.93,62.93,0,0,1,72.66-47.37c1.52,0,124.74,29.33,131.07,30.83,19.64,4.36,40.41,9.88,47-8,6.71-18.24-5.45-25.79-22.22-36.61a182.08,182.08,0,0,1-32.22-25.74c-35.82-35.64-47.45-86.38-47.53-118.88C160.09,76,237.46.25,330.43,0S501.15,75.16,501.35,168.39Z",
    fill: "#609",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivo119);
export default __webpack_public_path__ + "static/media/vivo-119.f9389f634582b2a68a80a9c44f02df95.svg";
export { ForwardRef as ReactComponent };